'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createFieldArray = require('./createFieldArray');

var _createFieldArray2 = _interopRequireDefault(_createFieldArray);

var _plain = require('./structure/plain');

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createFieldArray2.default)(_plain2.default);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/FieldArray.js
// module id = 1298
// module chunks = 0